import type { Project } from "./schema";

/** Managed references in authored data; opaque legacy source text does not attach assets. */
export function projectAssetIds(
  project: Project,
  available: readonly { id: string }[],
  options: { includeLibrary?: boolean } = {},
) {
  const known = new Set(available.map((asset) => asset.id)),
    found = new Set<string>(),
    seen = new Set<object>();
  const visit = (value: unknown) => {
    if (typeof value === "string") {
      if (known.has(value)) found.add(value);
      return;
    }
    if (!value || typeof value !== "object" || seen.has(value)) return;
    seen.add(value);
    if (Array.isArray(value)) value.forEach(visit);
    else
      for (const [key, child] of Object.entries(value))
        if (
          key !== "legacy" &&
          (value !== project ||
            key !== "assetLibrary" ||
            options.includeLibrary !== false)
        )
          visit(child);
  };
  visit(project);
  return found;
}
